module.exports = __webpack_public_path__ + "img/mc_tip.ffe7a1ba.png";